/* The Lexafide wordmark — official PNG mark.
   The "dark" variant uses the dark-ink wordmark (for light/cream backgrounds);
   `variant="onDark"` swaps to the white-recoloured wordmark for dark backgrounds.
   Sizes match the height tokens used across the site. */

const HEIGHT_CLASS = {
    sm: "h-5",
    md: "h-6 md:h-7",
    lg: "h-7 md:h-9",
    xl: "h-9 md:h-12",
};

const Wordmark = ({ className = "", size = "md", variant = "default" }) => {
    const src =
        variant === "onDark"
            ? "/brand/lexafide-wordmark-on-dark.png"
            : "/brand/lexafide-wordmark.png";

    return (
        <img
            src={src}
            alt="Lexafide"
            data-testid="lexafide-wordmark"
            loading="eager"
            decoding="async"
            // Native aspect ratio is 982 × 240 (≈ 4.09 : 1). `w-auto h-*` keeps it sharp.
            className={`block w-auto select-none ${HEIGHT_CLASS[size] || HEIGHT_CLASS.md} ${className}`}
            draggable={false}
            style={{ imageRendering: "auto" }}
        />
    );
};

export default Wordmark;
